import React, {Component, PureComponent} from 'react';
import styled from "styled-components";
import Tree, {TreeNode} from 'rc-tree';

const TreeWrapper = styled.div`
    display: inline-block;
    width: 15%;
    background-color: #f0f8ff;
    box-shadow: 0 0.25rem 0.75rem rgba(0,0,0,0.2);
    padding-bottom: 1.5rem;
    max-height: 100%;
`;

const NewPathWrapper = styled.div`
    display: inline-block;
    color: white;
    border-radius: .25rem;
    padding: .25rem 1rem;
    margin: 0.75rem 1rem;
    font-size: .9rem;
    letter-spacing: 0.05rem
    box-shadow: 0 0.25rem 0.75rem rgba(0,0,0,0.2);
    text-shadow: 0.2rem 0.2rem 0.4rem #222222;
    cursor:pointer;
`;

const ExploreTreeNode = styled(TreeNode)`
    font-family: Courier;
    letter-spacing: 0.1rem;
    font-weight:bold;
    color: black;
    margin: 0.5rem;
    padding: 0.25rem 0.5rem;
    border: 0.25rem double grey;
    border-radius: 0.25rem;
    background-color: grey;
    font-size: 0.8rem;
    width: fit-content;
    box-shadow: 0 0.25rem 0.75rem rgba(0,0,0,0.2);
    cursor: pointer;
    border-color: '#eeeeee';
`;

class NewPath extends PureComponent {
    render() {
        return <NewPathWrapper
            style={{background: 'linear-gradient(to bottom right, #99bbdd, #557799 )'}}
            onClick={this.props.onClick}>
            New Path
        </NewPathWrapper>
    }
}

const selectedBackground = 'linear-gradient(to bottom right, lightgreen, #bbbbbb)';
const normalBackground = 'linear-gradient(to bottom right, #eeeeee, #bbbbbb)';

export class ExploreTree extends Component {

    state = {
        newPath: [],
        explores: [],
        selected: null
    };

    componentDidMount() {
        this.loadExplores();
    };

    loadExplores() {
        const hostname = 'http://' + this.props.parsed.hostname + '/fracto/explores';
        fetch(hostname)
            .then(response => response.json())
            .then(data => this.setState({explores: data.explores}));
    }

    handleNewPath(e) {
        const newPath = 'http://' + this.props.parsed.hostname + '/fracto/explores/new'
        fetch(newPath)
            .then(response => response.json())
            .then(data => {
                const selected = data.newexplore.unique_id;
                this.props.onSelect(selected);
                this.setState({selected: selected})
                this.loadExplores();
            });
    };

    selectNode(item) {
        console.log('selectNode: ' + item);
        this.props.onSelect(item);
        this.setState({selected: item[0]});
    }

    render() {
        const treeNodes = this.state.explores.map((item, key) => {
            return <ExploreTreeNode
                style={{background: item.unique_id === this.state.selected ? selectedBackground : normalBackground}}
                title={item.name} key={item.unique_id}
            />
        });
        return <TreeWrapper>
            <NewPath onClick={(e) => this.handleNewPath(e)}/>
            <Tree onSelect={(item) => this.selectNode(item)}>
                {treeNodes}
            </Tree>
        </TreeWrapper>
    }
}

export default ExploreTree;
